module.exports = __webpack_public_path__ + "img/Welcome-amico.9fab9aa8.svg";